import React from "react";
import Header from "../common/Header/header.jsx";
import ClimateImg from "../../assets/climateImg.png";
import Footer from "../common/Footer/footer.jsx";
import AreaOfInterestPage from "../AreaOfInterest/areaOfInterest.jsx";
import "./home.css";

const Home = () => {
  return (
    <>
      <Header />
      <main className="home-main my-2">
        <div className=" portfolio-intro">
          <h1 className="main-heading">
            Welcome to Terrestrial Hydrology Group
          </h1>
          <p className=" intro-paragraph">
            I am an Assistant Professor specializing in Hydraulics Engineering,
            with a focus on sustainable groundwater management hydrological
            cycles, and innovative technologies like remote sensing and machine
            learning methods. My research centers on identifying hydro-climatic
            extremes and developing mitigation strategies.
          </p>
        </div>
        <img className="w-100 h-50" src={ClimateImg} alt=""></img>
      </main>
      <AreaOfInterestPage />

      <Footer />
    </>
  );
};

export default Home;
